<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="余额" prop="user">
              <a-input v-model="details.balance" placeholder=""> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="可提现金额" prop="password">
              <a-input v-model="details.freeMoney" type="text" placeholder="">
              </a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" html-type="submit" @click="withdrawal">
                提现
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <a-modal
      centered
      v-model="visible"
      title="余额提现"
      @ok="handleOk"
      class="modals"
    >
      <p>提现方式</p>
      <a-radio-group name="radioGroup" :default-value="1" @change="onChange">
        <a-radio :value="1"> 支付宝 </a-radio>
        <a-radio :value="2"> 银行卡 </a-radio>
      </a-radio-group>
      <div v-if="right == 1">
        <p>提现金额</p>
        <a-input
          v-model="formInline.money"
          placeholder="请输入提现金额，精确到分（单位：元）"
        />
        <span>支付宝账号</span>
        <a-input v-model="formInline.aliAccount" placeholder="Basic usage" />
        <span>实名名称</span>
        <a-input v-model="formInline.aliRealName" placeholder="Basic usage" />
        <span>验证码</span>
        <a-input v-model="formInline.phone" placeholder="Basic usage" />
        <a-button>获取验证码</a-button>
      </div>
      <div v-else>
        <!-- <p>提现金额</p>
        <a-input
          v-model=""
          placeholder="请输入提现金额，精确到分（单位：元）"
        /> -->
        <p>提现金额</p>
        <a-input
          v-model="formInlines.money"
          placeholder="请输入提现金额，精确到分（单位：元）"
        />
        <span>开户银行</span>
        <a-select
          v-model="formInlines.bankName"
          default-value="lucy"
          style="width: 120px"
          @change="handleChange"
        >
          <a-select-option
            v-for="(item, index) in dropDown"
            :key="index"
            :value="item.name"
          >
            {{ item.name }}
          </a-select-option>
          <!-- <a-select-option :item.name  \\value=""> Lucy </a-select-option>
          <a-select-option value="disabled" disabled>
            Disabled
          </a-select-option>
          <a-select-option value="Yiminghe"> yiminghe </a-select-option> -->
        </a-select>
        <span>支行名称</span>
        <a-input
          v-model="formInlines.branchBankName"
          placeholder="请输支行名称"
        />
        <span>银行卡号</span>
        <a-input
          v-model="formInlines.bankCardNum"
          placeholder="请输入银行卡号"
        />
        <span>持卡人</span>
        <a-input
          v-model="formInlines.bankCardName"
          placeholder="请输入持卡人名称"
        />
        <span>验证码</span>
        <a-input v-model="formInlines.phone" placeholder="Basic usage" />
        <a-button>获取验证码</a-button>
      </div>
    </a-modal>
    <!-- <a-modal centered v-model="visibleTwo" title="Basic Modal" @ok="handleOk">
      <p>提现方式</p>
      <a-radio-group name="radioGroup" :default-value="1" @change="onChange">
        <a-radio :value="1"> 支付宝 </a-radio>
        <a-radio :value="2"> 银行卡 </a-radio>
      </a-radio-group>
      <p>提现金额</p>
      <a-input placeholder="请选择银行卡所属银行" />
      <p>开户银行</p>
      <a-select
        mode="tags"
        style="width: 100%"
        :token-separators="[',']"
        @change="handleChange"
      >
        <a-select-option v-for="i in 25" :key="(i + 9).toString(36) + i">
          {{ (i + 9).toString(36) + i }}
        </a-select-option>
      </a-select>
      <p>支行名称</p>
      <a-input placeholder="请输入支行名称" />
      <p>银行卡号</p>
      <a-input placeholder="请输入银行卡号" />
      <p>持卡人</p>
      <a-input placeholder="请输入持卡人名称" />
      <p>验证码</p>
      <a-input placeholder="请输入手机号验证码" />
      <a-button>获取验证码</a-button>
    </a-modal> -->
    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <storeWalletContent ref="bbb"></storeWalletContent>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import {
  storeTixianWalletList,
  storeTixianWalletListdropDown,
  storeWalletListDetail,
} from "@/api/storeApi.js";
import storeWalletContent from "./storeWalletContent.vue";
import { message } from "ant-design-vue";
export default {
  components: {
    storeWalletContent,
  },
  data() {
    return {
      details: "",
      right: 0,
      dropDown: "",
      visible: false,
      visibleTwo: false,
      formInline: {
        money: "",
        aliAccount: "",
        aliRealName: "",
        code: "1321",
        phone: "",
        type: "1101",
      },
      formInlines: {
        money: "",
        bankName: "",
        branchBankName: "",
        bankCardNum: "",
        bankCardName: "",
        code: "0000",
        type: "1103",
      },
    };
  },
  created() {
    this.getStoreTixianWalletListdropDown();
    this.getStoreWalletListDetail();
  },
  methods: {
    handleSubmit(e) {
      // console.log(this.formInline);
    },
    onChange(e) {
      this.right = e.target.value;
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    withdrawal() {
      this.visible = true;
    },
    // 获取门店钱包余额信息
    getStoreWalletListDetail() {
      storeWalletListDetail().then((res) => {
        this.details = res.data;
      });
    },
    // 开户银行下拉框
    getStoreTixianWalletListdropDown() {
      storeTixianWalletListdropDown().then((res) => {
        this.dropDown = res.data;
      });
    },
    handleChange() {},
    // 确定回调
    handleOk() {
      this.visible = false;
      if (this.right === 1) {
        storeTixianWalletList(this.formInline).then((res) => {
          message.success(res.info);
          this.getStoreWalletListDetail();
          this.$refs.bbb.getStoreWalletList();
        });
      } else {
        storeTixianWalletList(this.formInlines).then((res) => {
          message.success(res.info);
          this.getStoreWalletListDetail();
          this.$refs.bbb.getStoreWalletList();
        });
      }
    },
  },
};
</script>
<style scoped>
.modals {
  display: block;
  display: flex;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/views/financialManagement/storeWallet/storeWallet.vue